import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';

import {AnalyticsModule} from 'app/analytics/analytics.module';
import {UIModule} from 'app/ui/ui.module';
import {UIDialogCloseDirective} from 'app/ui/dialog/dialog.directive';
import {UISvgIconModule} from 'app/ui/svg-icon/svg-icon.module';

import {FeatureRequestComponent} from './feature-request.component';
import {FeatureRequestDirective} from './feature-request.directive';
import {RequestConfirmationComponent} from './request-confirmation.component';
import {RequestConfirmationDirective} from './request-confirmation.directive';

@NgModule({
    imports: [
        AnalyticsModule,
        CommonModule,
        FormsModule,
        UIModule,
        UISvgIconModule
    ],
    declarations: [
        FeatureRequestComponent,
        FeatureRequestDirective,
        RequestConfirmationDirective,
        RequestConfirmationComponent
    ],
    entryComponents: [
        FeatureRequestComponent,
        RequestConfirmationComponent
    ],
    exports: [
        FeatureRequestDirective,
        FeatureRequestComponent,
        RequestConfirmationDirective,
        RequestConfirmationComponent
    ]
})
export class FeatureRequestModule {
}